export enum MfaRequestStatus {
  REDEEMED = 'redeemed',
  EXPIRED = 'expired',
  VALID = 'valid',
}